// extracted by mini-css-extract-plugin
module.exports = {"DoneContainer":"Done_DoneContainer__2e03r","ThanksTitle":"Done_ThanksTitle__1Hwnh"};